/* BG-PROTECTION-ORPHAN-GUARD v1 (2026-10-19, order #45332 fix).
 * Shipping Protection Insurance may never be the only thing in a cart.
 * - After any cart change (and on page load / bfcache restore), if the cart has protection lines but no
 *   shippable product, the protection lines are removed (cart then empty) and the cart UI is refreshed.
 * - The protection product page itself redirects to /cart (it is not a standalone product).
 * Normal carts (bottle + protection) are never touched. Server-side backstop: "Protection-only cart block"
 * cart & checkout validation function (Bourbon Group app).
 * Rollback: remove the render line marked BG-PROTECTION-ORPHAN-GUARD in layout/theme.liquid and delete this asset.
 */
(function () {
  if (window.__bgProtGuard) return;
  window.__bgProtGuard = true;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var HANDLE_RE = /^(shipping-protection|delivery-guarantee)/i;
  function isProt(i) {
    var t = String(i.product_type || '').toLowerCase();
    var h = String(i.handle || '');
    var s = String(i.sku || '').toUpperCase();
    return t === 'shipping protection' || HANDLE_RE.test(h) || s.indexOf('SHIP-PROT') === 0 || s.indexOf('SIMPINSUR') === 0;
  }
  if (/\/products\/(shipping-protection|delivery-guarantee)(?:[-\w]*)\/?$/i.test(location.pathname)) {
    location.replace(root + 'cart');
    return;
  }
  var nativeFetch = window.fetch.bind(window);
  var busy = false, again = false;
  function check() {
    if (busy) { again = true; return; }
    busy = true;
    nativeFetch(root + 'cart.js', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = (cart && cart.items) || [];
        var prot = items.filter(isProt);
        if (!prot.length) return;
        var hasGoods = items.some(function (i) { return !isProt(i) && !i.gift_card && i.requires_shipping !== false; });
        if (hasGoods) return;
        var updates = {};
        prot.forEach(function (i) { updates[i.key] = 0; });
        return nativeFetch(root + 'cart/update.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ updates: updates })
        }).then(function () {
          try { console.info('[bg-protection-guard] removed orphan shipping protection'); } catch (e) {}
          var path = location.pathname.replace(/\/$/, '');
          if (/\/cart$/.test(path)) { location.reload(); return; }
          document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true }));
          document.dispatchEvent(new CustomEvent('bg:protection-orphan-removed', { bubbles: true }));
        });
      })
      .catch(function () {})
      .then(function () { busy = false; if (again) { again = false; setTimeout(check, 300); } });
  }
  var CART_WRITE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  window.fetch = function (input, init) {
    var p = nativeFetch.apply(null, arguments);
    try {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      if (CART_WRITE.test(url)) p.then(function () { setTimeout(check, 350); }, function () {});
    } catch (e) {}
    return p;
  };
  var xo = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (m, url) {
    try {
      if (CART_WRITE.test(String(url))) this.addEventListener('loadend', function () { setTimeout(check, 350); });
    } catch (e) {}
    return xo.apply(this, arguments);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', check); else check();
  window.addEventListener('pageshow', function (e) { if (e.persisted) check(); });
})();
